<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subtitle-1">{{ $t("labels.groups") }}</h1>
        </v-toolbar-title>
        <v-btn color="teal" dark="dark" small absolute="absolute" bottom="bottom" right fab="fab" @click="newGroup">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-title class="mt-0">
        <v-flex xs12 sm4="sm4">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line="single-line" hide-details
            clearable="clearable">
          </v-text-field>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="groups" :loading="loading" :search="search"
          :items-per-page="itemsPerPage">
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-left small-td">
                {{ item.createdAt | moment('LL') }}
              </td>
              <td class="text-left small-td">{{ item.groupName }}</td>
              <td class="text-left small-td">{{ item.code }}</td>
              <td class="justify-end layout px-0">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item @click="editGroup(item)">
                      <v-list-item-title>{{ $t("buttons.edit") }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteGroup(item)">
                      <v-list-item-title>{{ $t("buttons.delete") }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.</v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import groupService from "../service.js";
import { mapGetters } from "vuex";

export default {
  name: "group-list",
  data() {
    return {
      dialog: false,
      sortBy: "createdAt",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      terminalURL: process.env.VUE_APP_TERMINALURL,
      headers: [
        {
          text: this.$t("labels.createdAt"),
          align: "left",
          sortable: true,
          value: "createdAt",
          width: "10%"
        },
        {
          text: this.$t("labels.groupName"),
          value: "groupName",
          sortable: true
        },
        {
          text: this.$t("labels.password"),
          value: "code",
          sortable: false
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      search: null,
      groups: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "groupName"
      }
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters("global", ["currentOrganization", "currentUser", "organizationList"])
  },
  methods: {
    editGroup(group) {
      this.$router.push({ name: "edit-group", params: group });
    },
    newGroup() {
      this.$router.push({ path: "/group/new" });
    },
    getList() {
      return groupService.getAll(this.currentOrganization.organizationID).then(response => {
        if (response && response.data) {
          this.groups = response.data;
        }
        this.loading = false;
        return response;
      });
    },
    deleteGroup(group) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return groupService
            .delete(group.id)
            .then(response => {
              if (response.data) {
                this.$swal("Deleted!", "Group has been deleted.", "success");
                this.$Progress.finish();
                this.getList();
              }
            })
            .catch(error => {
              this.$toasted.error(error.data.message, {
                position: "top-right",
                showHideTransition: "slide",
                icon: "error",
                duration: 5000
              });
              this.$Progress.fail();
            });
        }
      });
    },
    viewLocation(location) {
      this.$router.push({ path: `/location/${location.storeID}/profile` });
    }
  }
};
</script>
